export const API_GET_RETURNED_ADDRESSES = "API_GET_RETURNED_ADDRESSES"
export const RESET_RETURNED_ADDRESSES = "RESET_RETURNED_ADDRESSES"
